import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import VizsgaTableDto from '../dto/VizsgaTableDto';

class VizsgaTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgaTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<VizsgaTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VizsgaTableDto)))
				.catch(reject);
		});
	}
}

export default new VizsgaTableService();
